import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

import DatePresenter, { SHORT_FORMAT } from '../../presenters/DatePresenter';
import StorePresenter from '../../presenters/StorePresenter';
import FormHeader from '../../components/FormHeader';
import Group from '../../components/Group';
import Row from '../../components/Row';
import Column from '../../components/Column';
import { Label } from '../../components';

import RateLists from './components/RateLists';

export const CashbackRates = (props) => {
  const { brand, searchParams, onSearchParamsChange } = props;

  const defaultCashbackRates = StorePresenter.defaultCashbackRates(brand);
  const birthdayCashbackRates = StorePresenter.birthdayCashbackRates(brand);
  const [startDate, setStartDate] = useState(DatePresenter.today());
  const [endDate, setEndDate] = useState(DatePresenter.oneMonthAhead());

  const handleStartDateChange = (date) => {
    setStartDate(DatePresenter.shortFormattedDate(date));
  };

  const handleEndDateChange = (date) => {
    setEndDate(DatePresenter.shortFormattedDate(date));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    onSearchParamsChange({
      ...searchParams,
      afterDate: startDate,
      beforeDate: endDate,
    });
  };

  return (
    <div>
      <FormHeader title={`${StorePresenter.name(brand)} cashback rates`}>
        <input
          id="userFind"
          className="user-find-submit"
          type="submit"
          onClick={handleSubmit}
          defaultValue="Find"
        />
      </FormHeader>

      <Group>
        <Row className="dates">
          <Column className="date">
            <Label attr="startDate" text="Start date" />
            <DatePicker
              selected={DatePresenter.dateObject(startDate)}
              onChange={(date) => handleStartDateChange(date)}
              dateFormat="MM-dd-yyyy"
            />
          </Column>
          <Column className="date">
            <Label attr="endDate" text="End date" />
            <DatePicker
              selected={DatePresenter.dateObject(endDate)}
              onChange={(date) => handleEndDateChange(date)}
              dateFormat="MM-dd-yyyy"
            />
          </Column>
        </Row>
      </Group>
      <RateLists
        defaultRates={defaultCashbackRates}
        birthdayRates={birthdayCashbackRates}
      />
    </div>
  );
};

export default CashbackRates;

CashbackRates.propTypes = {
  brand: StorePresenter.shape().isRequired,
  searchParams: PropTypes.shape().isRequired,
  onSearchParamsChange: PropTypes.func.isRequired,
};
